import { translate, translateRich, useLocale } from "../../localization";
import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AppButton, Panel } from "../ui";

const getCollectionName = (collection) =>
  collection?.name || collection?.collectionName || collection?.title || translate("Untitled Collection");

const getCollectionDescription = (collection) =>
  collection?.description || collection?.summary || translate("No Description");

const CollectionCollectionsSection = ({ collections }) => {
  useLocale();
  const navigate = useNavigate();
  const [collectionsState, setCollectionsState] = useState(collections || []);

  useEffect(() => {
    setCollectionsState(collections || []);
  }, [collections]);

  return (
    <section className="collectionDetailSection">
      <Typography className="collectionDetailSectionTitle" variant="h5">{translateRich("Collections ({value0})", {
  value0: collectionsState.length
})}</Typography>

      <div className="collectionsList app-row-list">
        {collectionsState.map((collection) => (
          <Panel key={collection.id} className="collectionCard" hoverable>
            <div className="collectionCardContent">
              <div className="collectionCardInfo">
                <div className="collectionCardName">{getCollectionName(collection)}</div>
                <div className="collectionCardId">{collection?.id || translate("No ID")}</div>
                {collection?.status?.type && (
                  <div className="collectionCardStatus">{collection.status.type}</div>
                )}
              </div>

              <div className="collectionCardDesc">
                {getCollectionDescription(collection)}
              </div>

              <div className="collectionCardActions">
                <AppButton
                  className="collectionCardBtn"
                  kind="secondary"
                  onClick={() => navigate(`/collections/${collection.id}`)}
                >{translate("Open")}</AppButton>
              </div>
            </div>
          </Panel>
        ))}
      </div>
    </section>
  );
};

export default CollectionCollectionsSection;
